<template>
  <div class="container module">
    <PageHeader :height="1080" type="image" v-if="!!banner" :image="banner" />

    <div class="sction pagenav">
      <PageNavbar />
    </div>

    <div class="items">
      <div
        class="item"
        v-for="(cat, idx) in items"
        :key="cat.id"
        :class="[idx % 2 == 0 ? '' : 'odd']"
      >
        <div class="left">
          <div class="title">{{ cat.title }}</div>
          <div class="subtitle">{{ cat.subtitle }}</div>
          <div class="desc">
            {{ cat.desc }}
          </div>
        </div>
        <div class="right">
          <el-image class="item-img" :src="cat.thumb"></el-image>
        </div>
      </div>
    </div>

    <page-footer />
  </div>
</template>

<script>
import PageFooter from "../components/PageFooter.vue";
import PageHeader from "../components/PageHeaderV2.vue";
import PageNavbar from "../components/PageNavbar.vue";
import Filters from "../components/Filters.vue";
import AlbumList from "../components/AlbumList.vue";
import Api from "../utils/api";
import { mapGetters } from "vuex";
export default {
  name: "Series",
  components: {
    PageFooter,
    PageNavbar,
    PageHeader,
    Filters,
    AlbumList,
  },
  computed: {
    // ...mapGetters(["getPageData"]),
    // banner() {
    //   let key = "about";
    //   let page = this.getPageData;
    //   return !!page[key] ? page[key] : false;
    // },
  },
  methods: {
    getSeries(id) {
      Api.getSeries(id).then((res) => {
        console.log(" cat", res);
        this.items = res.items;
        this.banner = res.banner;
        this.cat = res.cat;
      });
    },
  },
  watch: {
    $route: function (nv, ov) {
      let id = nv.params.id;
      this.getSeries(id);
    },
  },
  created() {
    const { id } = this.$route.params;
    this.getSeries(id);
  },
  data() {
    return {
      showFilter: false,
      cat: {},
      banner: "",
      items: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.pagenav {
  position: relative !important;
  z-index: 999;
  display: flex;
  justify-content: center;
}

.items {
  margin-top: 180px;
  margin-right: 200px;
  margin-left: 200px;
  .item {
    display: flex;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    margin-bottom: 200px;
    &.odd {
      flex-direction: row-reverse;
      .left {
        margin-left: 75px;
        margin-right: 0;
      }
    }

    &-img {
      width: 975px;
      height: 650px;
    }

    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 75px;
      .title {
        font-size: 50px;
        line-height: 59px;
      }

      .desc {
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
        color: #3f3f3f;
        margin-top: 245px;
      }

      .subtitle {
        margin-top: 38px;
        font-size: 25px;
        line-height: 29px;
      }
    }

    .right {
    }
  }
}

.module {
  background-color: #fff;
}

.navi {
  position: relative;
  display: flex;
  justify-content: center;

  .inn {
    margin-top: -75px;
  }
}
</style>
